import apiClient from './client';

/* ---------- Types ---------- */

export interface PromptPreview {
  section: string;
  base_prompt: string | null;
  rendered_with_rules: string | null;
}

export interface ProfileView {
  kind: string;
  active: {
    id: string;
    kind: string;
    version: number;
    payload: Record<string, unknown>;
    source_yaml_hash: string;
    loaded_at: string | null;
    is_active: boolean;
  } | null;
  canonical_yaml: string | null;
  canonical_yaml_hash: string | null;
  canonical_present: boolean;
  prompt_previews: PromptPreview[];
}

export interface RulesProfileResponse {
  intake: ProfileView;
  determination: ProfileView;
}

export interface ReloadSummary {
  [kind: string]: Record<string, unknown>;
}

/* ---------- Admin profile endpoints ---------- */

export async function getRulesProfile(): Promise<RulesProfileResponse> {
  const { data } = await apiClient.get<RulesProfileResponse>('/admin/rules-profile');
  return data;
}

export async function reloadRulesProfile(): Promise<ReloadSummary> {
  const { data } = await apiClient.post<{ summary: ReloadSummary }>(
    '/admin/rules-profile/reload'
  );
  return data.summary;
}

/* ---------- Per-case master-doc override ---------- */

export interface RulesOverride {
  id: string;
  case_id: string;
  master_document_id: string;
  reason: string | null;
  created_by: string | null;
  created_at: string | null;
  superseded_at: string | null;
}

export interface OverrideResponse {
  override: RulesOverride | null;
  default_master_category: string | null;
}

export async function getCaseRulesOverride(caseId: string): Promise<OverrideResponse> {
  const { data } = await apiClient.get<OverrideResponse>(
    `/cases/${caseId}/rules-override`
  );
  return data;
}

export async function setCaseRulesOverride(
  caseId: string,
  input: { master_document_id: string; reason?: string | null }
): Promise<OverrideResponse> {
  const { data } = await apiClient.put<OverrideResponse>(
    `/cases/${caseId}/rules-override`,
    input
  );
  return data;
}

/* ---------- Per-case discrepancies ---------- */

export interface DiscrepancyItem {
  id: string;
  case_id: string;
  field_name: string;
  master_document_id: string;
  master_doc_category: string | null;
  master_value: string | null;
  conflicting_document_id: string;
  conflicting_doc_category: string | null;
  conflicting_value: string | null;
  created_at: string | null;
}

export interface DiscrepancyListResponse {
  items: DiscrepancyItem[];
  total: number;
}

export async function getCaseDiscrepancies(
  caseId: string
): Promise<DiscrepancyListResponse> {
  const { data } = await apiClient.get<DiscrepancyListResponse>(
    `/cases/${caseId}/discrepancies`
  );
  return data;
}